module.exports = __webpack_public_path__ + "img/desert.be5030ca.webp";